import { NgModule }           from "@angular/core";
import { CommonModule }        from "@angular/common";
import { FormsModule }         from "@angular/forms";
import { LostCredentialsConfirmation } from "./lostCredentials.confirmation";
import { CREDENTIALROUTING }            from "./lostCredentials.route";
import { LostCredentialsComponent }   from "./lostCredentials.component";

@NgModule({
  imports: [CommonModule, FormsModule, CREDENTIALROUTING],
  declarations: [LostCredentialsComponent, LostCredentialsConfirmation]
})

export class LostCredentialsModule { }




// WEBPACK FOOTER //
// ./src/app/modules/lostCredentials/lostCredentials.module.ts